import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthService, NovitaetenLookupService, StatistikService } from 'FoxxyLib';
import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';


export interface IDashBoardInfo
{
  text: string;
  islieferant: boolean;
}
@Component({
    selector: 'app-dashboard',
    templateUrl: 'dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false,
    providers:[StatistikService]
})

export class DashboardComponent implements OnInit {


  ismanager: boolean = false;
  selecthasSOMADiagramm$: Observable<boolean>;
  /**#8843: einmal angelegt - eine Methode im Template lieferte bei jeder Change Detection ein neues Observable */
  dashBoardInfos$: Observable<IDashBoardInfo[]>;

    constructor(private store: Store<any>,
      private statistikService : StatistikService,
      private authService: AuthService) {

        this.authService.getLipoUser().subscribe(user=> this.ismanager = user.ismanager);
        this.selecthasSOMADiagramm$ =  this.statistikService.selecthasSOMADiagramm$;
        this.dashBoardInfos$ = this.getDashBoardInfos();
    }

    /**Vorläufigen Text anzeigen */
    getDashBoardInfos() : Observable<IDashBoardInfo[]>
    {
      return this.authService.getLipoUser().pipe(map(user=>
        {
            if (user.isadmin == true || user.ismanager == true)
            {
                return [<IDashBoardInfo> { islieferant: false, text: 'Cockpit Lieferantenportal' }];
            } else
            {
              return [<IDashBoardInfo> { islieferant: true, text:  'Herzlich Willkommen im Lieferantenportal<br>der Buchhandlung Hugendubel!'}        ];
            }
        }))
    }

    ngOnInit() {

      this.authService.getLipoUser().pipe(take(1)).subscribe(user=>
      {
         this.statistikService.loadDashboardStatistik(user);
      })

    }

}
